<template>
  <div class="home">
    <logo v-if="$store.state.mode !== 'iframe'" />
    <br v-else />
    <div v-if="error" class="loadingDiv">
      <h2>{{error}}</h2>
    </div>
    <div v-else-if="userData === 'loading'" class="loadingDiv">
      <loading />
    </div>
    <transition v-else name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import logo from "@/components/logo";
import loading from "@/components/loading";
export default {
  components: {
    loading,
    logo
  },
  props: {
    introducerID: String
  },
  data: function() {
    return {
      error: false
    };
  },
  computed: {
    userData: function() {
      return this.$store.state.userData;
    }
  }
};
</script>
<style lang="scss">
.button {
  padding: 0.75em;
  margin-top: 2em;
  border-radius: 7px;
  min-width: 100px;
  background-color: var(--base-colour, #535450);
  color: white;
  border: solid var(--hover-colour, rgb(201, 201, 201)) 1px;
}
.Enabled {
  &:hover {
    background-color: var(--hover-colour, #535450);
    cursor: pointer;
  }
}
.Disabled {
  opacity: 0.4;
}
.shadow {
  @media (min-width: 450px) {
    box-shadow: 3px 3px 15px var(--hover-colour, #535450);
  }
}
.shaded {
  background-color: rgba(255, 255, 255, 0.8);
}
.toplined {
  border-top: solid var(--base-colour, #535450) 2px;
}
.rounded {
  border-radius: 7px;
  border: solid var(--base-colour, #535450) 2px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.75);
  @media (max-width: 450px) {
    border-radius: 0;
    border-left: 0;
    border-right: 0;
    width: 100%;
  }
}
.detailBox {
  padding: 2em;
  * {
    margin-top: 1em;
    margin-bottom: 1em;
  }
  @media (max-width: 450px) {
    border-radius: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
}

.inverted {
  color: white;
  background-color: var(--base-colour, #535450);
}
.home {
  min-height: 100%;
  outline: solid var(--base-colour, #535450) 1px;
  display: grid;
  grid-template-rows: auto 1fr;
}
.booleanBox {
  display: flex;
  align-items: center;
  justify-content: center;
  * {
    margin-left: 0.6em;
    margin-right: 0.6em;
  }
}

.loadingDiv {
  width: 40vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-leave-active {
  transform: translateY(-25px);
}
</style>